import { render, staticRenderFns } from "./loadProcssName.vue?vue&type=template&id=2a705ae4&"
import script from "./loadProcssName.vue?vue&type=script&lang=js&"
export * from "./loadProcssName.vue?vue&type=script&lang=js&"
import style0 from "./loadProcssName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a705ae4')) {
      api.createRecord('2a705ae4', component.options)
    } else {
      api.reload('2a705ae4', component.options)
    }
    module.hot.accept("./loadProcssName.vue?vue&type=template&id=2a705ae4&", function () {
      api.rerender('2a705ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/loadProcssName.vue"
export default component.exports